import { useNotesForEntity } from 'app/agriculture/infobox/notes/useNotesForEntity';
import { useTasksForEntity } from 'app/agriculture/infobox/tasks/TasksForEntity/useTasksForEntity';
import { useContext } from 'react';
import { useHerdRemoveMutation } from 'app/agriculture/mutations/herds/useHerdRemoveMutation';
import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { Dialog } from 'app/agriculture/components/Dialog/Dialog';
import { ServicesContext } from 'app/items/shared/context_interface';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';
import { useNavigate } from 'react-router-dom';

interface HerdDeleteDialogProps {
    herdId: string;
}

export function HerdDeleteDialog({ herdId }: HerdDeleteDialogProps) {
    const { agricultureToastService } = useContext(ServicesContext);
    const navigate = useNavigate();
    const farmPath = useFarmPath();
    const attachedNotes = useNotesForEntity(herdId);
    const attachedTasks = useTasksForEntity(herdId);

    const hasAttachments = attachedNotes.length + attachedTasks.length > 0;

    const { mutate: deleteHerd } = useHerdRemoveMutation({
        onError: (error) => {
            navigate(-1);
            console.error('Error deleting herd', error);
            agricultureToastService
                .showToast({
                    title: 'Failed to delete herd:',
                    subtext: 'Something went wrong',
                    type: AgricultureToastType.ERROR,
                    variant: 'simple',
                })
                .catch((e) => {
                    console.error(e);
                });
        },
    });

    return (
        <Dialog
            disableCloseButton
            actions={{
                primaryAction: {
                    text: 'Delete it',
                    theme: 'danger',
                    onClick: () => {
                        navigate(farmPath('/'), { replace: true });
                        deleteHerd(herdId);
                    },
                },
                backAction: {
                    startIcon: undefined,
                    text: 'Cancel',
                    variant: 'contained',
                    onClick: () => {
                        navigate(-1);
                    },
                },
            }}
        >
            <h5>Are you sure you want to delete this herd?</h5>
            {!hasAttachments ? null : (
                <>
                    <p>Warning: This herd has the following attachments:</p>
                    <ul>
                        {attachedNotes.length > 0 && <li>Notes: {attachedNotes.length}</li>}
                        {attachedTasks.length > 0 && <li>Tasks: {attachedTasks.length}</li>}
                    </ul>
                </>
            )}
        </Dialog>
    );
}
